/* eslint-disable react/jsx-no-target-blank */
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import RedirectionModal from '../../../../app/common/components/modal/RedirectionModal';
import { useRedirectionModal } from '../../../../app/common/components/modal/hooks/useRedirectionModal';

const SidebarFooter = () => {
  const { isOpen, closeModal, handleContinue, pendingUrl, countdown } = useRedirectionModal();

  return (
    <>
      <div className="app-sidebar-footer px-6" id="kt_app_sidebar_footer">
        <div
          className={clsx('app-sidebar-menu')}
          style={{
            color: "white",
            bottom: 17,
            width: "100%",
            textAlign: "center",
            marginBottom: 15,
            fontSize: '1.1rem'
          }}
        >
          <hr />
          <Link
            to="/contact"
            className="link_footer"
            style={{
              display: 'block',
              color: '#fff',
              textDecoration: 'none',
              marginBottom: '0.5rem',
              textAlign: 'center',
            }}
          >
            <i className="bi bi-envelope" style={{marginRight: '8px', color:'#fff'}}></i>
            <span className="menu-title" style={{color: '#fff'}}>
              Contact
            </span>
          </Link>
        </div>
      </div>

      <RedirectionModal
        show={isOpen}
        onCancel={closeModal}
        onContinue={handleContinue}
        url={pendingUrl || ''}
        countdown={countdown}
      />
    </>
  );
};

export {SidebarFooter};
